import { all, fork } from 'redux-saga/effects';

// sagas
import chatSaga from '../../common/sagas/chat';

export default function* rootSaga() {
  yield all([fork(chatSaga)]);
}



// WEBPACK FOOTER //
// ./app/javascript/customer_chat/sagas/index.js